import { SearchType } from '@cvx/nextpage-typescript/lib-commonjs/utilities/enums'
import React, { useEffect, useContext } from 'react'
import { NextpageContext } from '../context/nextpage.context'

export type ISearchProps = {
  searchType: SearchType,
  searchRoot?: string
}

const Search = ({ searchType, searchRoot }: ISearchProps) => {
  const nextpage = useContext(NextpageContext)
  useEffect(() => {
    nextpage.UI.components.globalSearch()
    nextpage.UI.components.globalSiteSpecificSearch()
  })
  if (searchType === SearchType.SiteSpecific) {
    let target = ""
    if (searchRoot) {
      target = searchRoot
    }
    return (
      <form id='site-search' action='https://www.office.com/search?auth=2' target='_blank' method='get'>
        <h4>search this site</h4>
        <input id='site-search-filter' type='hidden' name='q' value={target}/>
        <input id='site-search-text' autoComplete='off' type='text' name='k' spellCheck='false' placeholder='enter keywords' aria-label='enter keywords'/>
        <button id='site-search-button' type='submit' title='search' aria-label='search'>
          <em className='icon-search'></em>
        </button>
      </form>
    )
  }
  return (
    <React.Fragment>
      <div id='search' role='search'>
        <form id='search-form' action='https://www.office.com/search?auth=2' target='_blank' method='get'>
          <em className='icon-search' aria-hidden='true'></em>
          <input id='search-text' autoComplete='off' type='text' name='q' spellCheck='false' placeholder='what can we help you find?' aria-label='what can we help you find?'/>
          <button id='search-clear' type='reset' title='clear' aria-label='clear search text'>
            clear
          </button>
          <button id='search-button' type='submit' title='search' aria-label='submit search'>
            <em className='icon-arrow-right'></em>
          </button>
        </form>
      </div>
      <span id='toggle-search' className='icon-search' role='button' aria-label='Toggle search form' aria-pressed='false'>
        <em>
          enterprise
          <br />
          search
        </em>
      </span>
    </React.Fragment>
  )
}

export default Search
